"use client"

import { Accordion } from "@chakra-ui/react/accordion"
import { HStack } from "@chakra-ui/react/stack"

import { Experience } from "@/types/getAbout"

import AccordionExperienceContent from "./AccordionExperienceContent"
import AccordionExperienceHeader from "./AccordionExperienceHeader"
import AccordionExperienceTimeline from "./AccordionExperienceTimeline"
import { getExperienceDuration } from "./utils"

interface AccordionExperienceItemProps {
  experience: Experience
  index: number
}

const AccordionExperienceItem = ({
  experience,
  index,
}: AccordionExperienceItemProps) => {
  const duration = getExperienceDuration(experience)

  return (
    <HStack
      alignContent="stretch"
      alignItems="stretch"
      className="card-item"
      flexDirection={{ lg: "row", lgDown: "row-reverse" }}
      flexWrap="nowrap"
      justifyContent="flex-start"
    >
      <HStack alignSelf="auto" className="collumn1" minWidth={0} width={"100%"}>
        <Accordion.Item
          _hover={{ borderColor: "primary.400" }}
          bg={"bg.paper"}
          borderColor="border"
          borderWidth="1px"
          flexGrow={1}
          position="relative"
          rounded="xl"
          transition="border .3s ease-out, transform 0.2s ease-out"
          value={experience.company.name}
        >
          <Accordion.ItemTrigger
            _hover={{ cursor: "pointer" }}
            data-umami-event={
              "accordion-experience-item" + experience.company.name
            }
            px={4}
            py={4}
          >
            <AccordionExperienceHeader
              duration={duration}
              experience={experience}
            />
          </Accordion.ItemTrigger>

          <Accordion.ItemContent>
            <AccordionExperienceContent experience={experience} />
          </Accordion.ItemContent>
        </Accordion.Item>
      </HStack>
      <AccordionExperienceTimeline index={index} />
      <HStack
        alignSelf="auto"
        className="collumn3"
        display={{ lg: "flex", lgDown: "none" }}
        minWidth={0}
        width={"100%"}
      />
    </HStack>
  )
}

export default AccordionExperienceItem
